
/* styles */
require("!!../../../../../../../.nvm/versions/node/v6.10.1/lib/node_modules/vue-cli/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?-autoprefixer&sourceMap!../../../../../../../.nvm/versions/node/v6.10.1/lib/node_modules/vue-cli/node_modules/vue-loader/lib/style-rewriter?id=data-v-25f3ff46&scoped=true!postcss-loader?sourceMap!../../../../../../../.nvm/versions/node/v6.10.1/lib/node_modules/vue-cli/node_modules/vue-loader/lib/selector?type=styles&index=0!./BackButton.vue")

var Component = require("!../../../../../../../.nvm/versions/node/v6.10.1/lib/node_modules/vue-cli/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../.nvm/versions/node/v6.10.1/lib/node_modules/vue-cli/node_modules/vue-loader/lib/selector?type=script&index=0!./BackButton.vue"),
  /* template */
  require("!!../../../../../../../.nvm/versions/node/v6.10.1/lib/node_modules/vue-cli/node_modules/vue-loader/lib/template-compiler?id=data-v-25f3ff46!../../../../../../../.nvm/versions/node/v6.10.1/lib/node_modules/vue-cli/node_modules/vue-loader/lib/selector?type=template&index=0!./BackButton.vue"),
  /* scopeId */
  "data-v-25f3ff46",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// /Users/andrewkahn/Documents/experiments/slate-interactives/src/components/slate-int-back-button/src/BackButton.vue
// module id = 33
// module chunks = 0